// @taxwar/client entry for players (index.html): the app (app/start.ts) with the committed presentation tuning
// (@taxwar/tuning values.json). A values file that breaks the knob table stops the page at once.

import { InvariantViolation } from '@taxwar/net'
import { parseTuning } from '@taxwar/tuning'
import committedTuning from '@taxwar/tuning/values.json'
import { startApp } from './app/start'
import { fixedTuning } from './tuning/link'

const host = document.getElementById('app')
if (!host) throw new InvariantViolation('index.html has no #app host element')

startApp({ host, tuning: fixedTuning(parseTuning(committedTuning, '@taxwar/tuning/values.json')) })
